import BaseModel from '@/model/BaseModel';
import { ModelCentralReprocessamentoErro } from '@/model/central-reprocessamento/ModelCentralReprocessamentoErro';
import { ModelUsuario } from '@/model/usuario/ModelUsuario';

/**
 * @typedef CentralReprocessamentoDTO
 * @property {number} id
 * @property {CENTRAL_REPROCESSAMENTO_TIPOS_ENUM} tipo
 * @property {string} nrinsc
 * @property {string} [razaoSocial]
 * @property {CENTRAL_REPROCESSAMENTO_STATUS_ENUM} status
 * @property {CentralReprocessamentoErroDTO} erro
 * @property {UsuarioDTO} criadoPorUsuario
 * @property {UsuarioDTO} iniciadoPorUsuario
 * @property {UsuarioDTO} interrompidoPorUsuario
 * @property {string} iniciadoEm
 * @property {string} finalizadoEm
 * @property {string} criadoEm
 * @property {string} atualizadoEm
 */
export class ModelCentralReprocessamento extends BaseModel {
  constructor() {
    super();
    this.id = null;
    this.tipo = null;
    this.nrinsc = null;
    this.razaoSocial = null;
    this.status = null;
    this.erro = null;
    this.criadoPorUsuario = new ModelUsuario();
    this.iniciadoEm = null;
    this.finalizadoEm = null;
    this.criadoEm = null;
    this.atualizadoEm = null;
  }

  /** @param {CentralReprocessamentoDTO} dto */
  static fromObject(dto) {
    const instance = new ModelCentralReprocessamento();
    instance.id = dto.id;
    instance.tipo = dto.tipo;
    instance.nrinsc = dto.nrinsc;
    instance.razaoSocial = dto.razaoSocial ?? null;
    instance.status = dto.status;
    instance.erro = dto.erro ? ModelCentralReprocessamentoErro.fromObject(dto.erro) : null;
    instance.criadoPorUsuario = dto.criadoPorUsuario
      ? ModelUsuario.fromObject(dto.criadoPorUsuario)
      : null;
    instance.iniciadoEm = dto.iniciadoEm;
    instance.finalizadoEm = dto.finalizadoEm;
    instance.criadoEm = dto.criadoEm;
    instance.atualizadoEm = dto.atualizadoEm;
    return instance;
  }
}
